import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import '../App.css';
import { useGameTimer } from '../hooks/useGameTimer';
import { useUrlManagement } from '../hooks/useUrlManagement';
import { useGameStore } from '../store/gameStore';
import { BottomControls } from './BottomControls';
import { GameBoard } from './GameBoard';
import { GameControls } from './GameControls';

export const Game: React.FC = () => {
  const { setSpymasterMode } = useGameStore();
  const [searchParams] = useSearchParams();
  
  // Initialize hooks
  useGameTimer();
  useUrlManagement();
  
  // Check for spymaster query parameter
  useEffect(() => {
    const isSpymaster = searchParams.get('spymaster') === 'true';
    setSpymasterMode(isSpymaster);
  }, [searchParams, setSpymasterMode]);

  return (
    <div className="App">
      <div className="game-container">
        <h1 className="game-title">KODENAMES</h1>
        <GameBoard />
        <GameControls />
        <BottomControls />
      </div>
    </div>
  );
};
